import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import API from '../../../create/api';
import querystring from 'querystring';
import Grid from '@material-ui/core/Grid';
import moment from 'moment';
import { useStore } from 'react-redux';
import MobileTableRow from './table.mobile-table-row';
import _ from 'lodash';
import Filters from './filter';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import MobilePagination from '../parcel/mobile.pagination';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

const useStyles = makeStyles((theme) => ({
  table: {
    minWidth: 700,
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  fromControl: {
    width: '100%',
  },
  tdBorder: { border: '1px black solid', fontSize: '20px', padding: '0 5px' },
  onlyPrint: { display: 'none' },
  hidePrint: {},
  printStyle: {},
  numberSize: { fontSize: '30px' },
  '@media print': {
    'table tr': {
      pageBreakBefore: 'always',
    },
    hidePrint: {
      display: 'none',
    },
    onlyPrint: { display: 'block' },
    printStyle: {
      border: '1px black solid',
      fontSize: '20px',
      padding: '0 5px',
    },
    numberSize: { fontSize: '30px' },
  },
}));

export default function RidersBook() {
  const classes = useStyles();
  const store = useStore();
  const location = useLocation();

  const ENABLE_ASSIGNED_DATE_FILTER = false;

  const getStatusFromUrl = () => {
    const params = new URLSearchParams(location.search);
    const statusInParam = params.get('status_in');
    if (statusInParam) {
      return statusInParam.split(',');
    }
    return [];
  };

  const [get_rows, setRows]: [any[], any] = useState([]);
  const [get_payment_date, set_payment_date] = useState<any>({
    startDate: moment().subtract(1, 'month').format('YYYY-MM-DD'),
    endDate: moment().format('YYYY-MM-DD'),
  });
  const [sums, setSums]: any = useState({});
  const [loading, setLoading] = useState(false);
  const [showFilters, setShowFilters] = useState(true);
  const [get_rider_assigned_date, set_rider_assigned_date] = useState<any>({
    startDate: '',
    endDate: '',
  });
  const [get_status, set_status] = React.useState<string[]>(getStatusFromUrl());
  const [get_total_parcel_count, set_total_parcel_count] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  const limit = useSelector((state: any) => state?.parcel?.parcelTableLimit);
  const sortBy = useSelector((state: any) => state?.parcel?.parcelTableSort);

  React.useEffect(() => {
    set_status(getStatusFromUrl());
  }, [location.search]);

  React.useEffect(() => {
    fetchAPI();
    // eslint-disable-next-line
  }, [get_status, limit, sortBy, currentPage]);

  function riderAssignedDateFilter() {
    if (!ENABLE_ASSIGNED_DATE_FILTER) {
      return {};
    }
    if (get_rider_assigned_date.startDate && !get_rider_assigned_date.endDate) {
      return {
        rider_assigned_at_gte: moment(get_rider_assigned_date.startDate).format('YYYY-MM-DD'),
        rider_assigned_at_lt: moment(get_rider_assigned_date.startDate).add(1, 'd').format('YYYY-MM-DD'),
      };
    }
    if (get_rider_assigned_date.startDate && get_rider_assigned_date.endDate) {
      return {
        rider_assigned_at_gte: moment(get_rider_assigned_date.startDate).format('YYYY-MM-DD'),
        rider_assigned_at_lt: moment(get_rider_assigned_date.endDate).add(1, 'd').format('YYYY-MM-DD'),
      };
    }
    return {};
  }

  function paymentDateFilter() {
    if (get_payment_date.startDate && !get_payment_date.endDate) {
      return {
        payment_date_gte: moment(get_payment_date.startDate).format('YYYY-MM-DD'),
        payment_date_lt: moment(get_payment_date.startDate).add(1, 'd').format('YYYY-MM-DD'),
      };
    }
    if (get_payment_date.startDate && get_payment_date.endDate) {
      return {
        payment_date_gte: moment(get_payment_date.startDate).format('YYYY-MM-DD'),
        payment_date_lt: moment(get_payment_date.endDate).add(1, 'd').format('YYYY-MM-DD'),
      };
    }
    return {};
  }

  async function fetchAPI() {
    setLoading(true);
    const set_date_filter = riderAssignedDateFilter();
    const set_payment_filter = paymentDateFilter();
    const param: {
      _limit?: number;
      status_nin?: string[];
      status_in?: string[];
      rider?: string;
      _sort?: string;
      _start?: number;
    } = {
      _limit: limit,
      _start: (currentPage - 1) * limit,
      _sort: sortBy,
      status_in: get_status,
      rider: store.getState().auth?.user?.rider?.id,
      ...set_date_filter,
      ...set_payment_filter,
    };

    const qs = querystring.encode(_.pickBy(param, _.identity));
    const countQs = querystring.encode(
      _.pickBy({ ...param, _limit: undefined, _start: undefined, _sort: undefined }, _.identity),
    );

    const url = `${process.env.REACT_APP_API_SERVER}/parcels?${qs}`;
    const countUrl = `${process.env.REACT_APP_API_SERVER}/parcels/count?${countQs}`;
    console.log(url);
    console.log(countUrl);

    try {
      const [parcels, count] = (await Promise.all([API.getAll(url), API.count(countUrl)])) as [any[], number];

      let totalCollected = 0;
      for (let i = 0; i < parcels.length; i++) {
        const parcel = parcels[i];
        if (['DELIVERED', 'DELIVERED_BY_RIDER'].includes(parcel.status)) {
          totalCollected += parcel.merchant_COD;
        }
        if (['RETURNED', 'RETURNED_BY_RIDER'].includes(parcel.status)) {
          continue;
        }
        if (['PARTIALLY_DELIVERED', 'PARTIALLY_DELIVERED_BY_RIDER'].includes(parcel.status)) {
          totalCollected += parcel.collected_amount;
        }
      }
      setSums({ totalCollected });
      setRows(parcels);
      set_total_parcel_count(count);
    } catch (error) {
      console.error('Failed to fetch parcels:', error);
    } finally {
      setLoading(false);
    }
  }

  function MobileNo(mobile_no: string = '') {
    if (mobile_no && mobile_no.includes(',')) {
      return mobile_no.split(',').map((num, i) => {
        num = num.trim();
        if (num.length === 11) {
          return (
            <span key={i}>
              {num}
              <br />
            </span>
          );
        } else {
          return (
            <span key={i}>
              ,<span style={{ color: 'red', textDecoration: 'line-through' }}>{num}</span>
            </span>
          );
        }
      });
    } else {
      return mobile_no && mobile_no.trim().length === 11 ? (
        mobile_no
      ) : (
        <span style={{ color: 'red', textDecoration: 'line-through' }}>{mobile_no}</span>
      );
    }
  }

  const handlePrint = () => {
    store.dispatch({ type: 'CLOSE_SIDEBAR' });
    setTimeout(() => {
      window.print();
    }, 100);
  };

  const paginationProps = {
    total: get_total_parcel_count,
    selected: 0,
    loading: loading,
    currentPage: currentPage,
    limit: limit,
    onPageChange: (newPage: number) => setCurrentPage(newPage),
    onLimitChange: (newLimit: number) => {
      store.dispatch({ type: 'UPDATE_PARCEL_TABLE_LIMIT', payload: newLimit });
      setCurrentPage(1);
    },
    onSortChange: (newSort: string) => {
      store.dispatch({ type: 'UPDATE_PARCEL_TABLE_SORT', payload: newSort });
      setCurrentPage(1);
    },
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Filters
          loading={loading}
          get_payment_date={get_payment_date}
          set_payment_date={set_payment_date}
          get_parcel_date={get_rider_assigned_date}
          set_parcel_date={set_rider_assigned_date}
          getStatus={get_status}
          setStatus={set_status}
          fetchAPI={fetchAPI}
          showFilters={showFilters}
          setShowFilters={setShowFilters}
          ENABLE_ASSIGNED_DATE_FILTER={ENABLE_ASSIGNED_DATE_FILTER}
        />
      </Grid>
      <Grid item xs={12} md={12} className={classes.hidePrint}>
        <div className="flex justify-between mb-5 p-4 bg-gray-100 rounded-lg shadow">
          <div className="p-2 font-bold border-primary-blue border-2 rounded shadow-blue-100 shadow-xl bg-white">
            Total Parcels: {get_rows.length}
          </div>
          <div className="p-2 font-bold border-green-500 border-2 rounded shadow-green-100 shadow-xl bg-white">
            Total Received: {sums.totalCollected?.toLocaleString() ?? 0}
          </div>
        </div>
      </Grid>
      <Grid item xs={12} md={12}>
        <MobilePagination {...paginationProps} />

        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '200px' }}>
            <CircularProgress />
          </Box>
        ) : (
          get_rows.map((row: any, i: number) => (
            <MobileTableRow key={row.id || i} row={row} index={(currentPage - 1) * limit + i} refreshData={fetchAPI} />
          ))
        )}

        <MobilePagination {...paginationProps} />
      </Grid>
    </Grid>
  );
}
